import { Box, Button, Heading, Text, VStack, HStack } from "@chakra-ui/react"
import { useNavigate } from "react-router-dom"

export const Page404 = () => {
  const nav = useNavigate()

  return (
    <Box
      minH="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)"
      position="relative"
      overflow="hidden"
    >
      <Box
        position="absolute"
        top="10%"
        right="10%"
        width="400px"
        height="400px"
        border="2px solid"
        borderColor="#0f4f6d"
        opacity={0.08}
        transform="rotate(45deg)"
        borderRadius="40px"
      />
      <Box
        position="absolute"
        bottom="10%"
        left="8%"
        width="250px"
        height="250px"
        borderRadius="full"
        border="2px solid"
        borderColor="#0f4f6d"
        opacity={0.1}
      />
      <Box
        position="absolute"
        top="40%"
        right="5%"
        width="150px"
        height="150px"
        borderRadius="full"
        border="2px solid"
        borderColor="#0f4f6d"
        opacity={0.06}
      />
      <Box
        position="absolute"
        bottom="30%"
        right="25%"
        width="80px"
        height="80px"
        bg="#0f4f6d"
        opacity={0.04}
        borderRadius="20px"
        transform="rotate(15deg)"
      />

      <VStack spacing={10} textAlign="center" zIndex={1} px={4}>
        <Box position="relative">
          <HStack spacing={4} alignItems="center" justifyContent="center" className="text-9xl">
            <Heading
              as="h1"
              fontSize={{ base: "120px", md: "180px" }}
              fontWeight="200"
              color="#0f4f6d"
              lineHeight="1"
              letterSpacing="-0.04em"
            >
              4
            </Heading>
            <Heading
              as="h1"
              fontSize={{ base: "120px", md: "180px" }}
              fontWeight="200"
              color="#0f4f6d"
              lineHeight="1"
              letterSpacing="-0.04em"
            >
              0
            </Heading>
            <Heading
              as="h1"
              fontSize={{ base: "120px", md: "180px" }}
              fontWeight="200"
              color="#0f4f6d"
              lineHeight="1"
              letterSpacing="-0.04em"
            >
              4
            </Heading>
          </HStack>
        </Box>

        <VStack spacing={4} pt={2}>
          <Heading as="h1" className="mb-4 text-4xl" fontSize={{ base: "2xl", md: "3xl" }} fontWeight="300" color="#0f4f6d" letterSpacing="tight">
            Página Não Encontrada
          </Heading>

          <Text fontSize={{ base: "md", md: "lg" }} color="gray.600" lineHeight="relaxed" fontWeight="300">
            A página que você está procurando não existe ou foi movida.
          </Text>

          <Text fontSize={{ base: "md", md: "lg" }} color="gray.500" lineHeight="relaxed" fontWeight="300">
            Esta mensagem também pode aparecer caso você não tenha permissão para acessar esta página.
          </Text>
        </VStack>

        <HStack spacing={4} pt={6} flexWrap="wrap" justifyContent="center">
          <Button
            bg="#0f4f6d"
            color="white"
            size="lg"
            px={10}
            py={6}
            fontWeight="400"
            fontSize="md"
            borderRadius="12px"
            _hover={{
              bg: "#0d4159",
              transform: "translateY(-3px)",
              boxShadow: "0 10px 25px rgba(15, 79, 109, 0.2)",
            }}
            transition="all 0.3s ease"
            onClick={() => nav("/")}
          >
            Voltar ao Início
          </Button>

          <Button
            variant="outline"
            borderColor="#0f4f6d"
            borderWidth="2px"
            color="#0f4f6d"
            size="lg"
            px={10}
            py={6}
            fontWeight="400"
            fontSize="md"
            borderRadius="12px"
            _hover={{
              bg: "#0f4f6d",
              color: "white",
              transform: "translateY(-3px)",
              boxShadow: "0 10px 25px rgba(15, 79, 109, 0.2)",
            }}
            transition="all 0.3s ease"
            onClick={() => nav(-1)}
          >
            Voltar
          </Button>
        </HStack>
      </VStack>
    </Box>
  )
}
